var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92288 6.33189H7.73867V3.85152C7.73867 3.77007 7.67203 3.70344 7.59059 3.70344H6.47997C6.39853 3.70344 6.33189 3.77007 6.33189 3.85152V6.33189H4.14768C4.06624 6.33189 3.9996 6.39853 3.9996 6.47997V7.59059C3.9996 7.67203 4.06624 7.73867 4.14768 7.73867H6.33189V10.219C6.33189 10.3005 6.39853 10.3671 6.47997 10.3671H7.59059C7.67203 10.3671 7.73867 10.3005 7.73867 10.219V7.73867H9.92288C10.0043 7.73867 10.071 7.67203 10.071 7.59059V6.47997C10.071 6.39853 10.0043 6.33189 9.92288 6.33189ZM15.1798 14.1802L12.4773 11.4777C14.7374 8.72156 14.5801 4.6382 11.996 2.05603C9.25651 -0.685342 4.80665 -0.685342 2.05603 2.05603C-0.685342 4.80665 -0.685342 9.25651 2.05603 11.996C4.6382 14.5801 8.72156 14.7374 11.4777 12.4773L14.1802 15.1798C14.2395 15.2316 14.3339 15.2316 14.3838 15.1798L15.1798 14.3838C15.2316 14.3339 15.2316 14.2395 15.1798 14.1802ZM11.015 11.015C8.81597 13.2121 5.25459 13.2121 3.05558 11.015C0.858413 8.81597 0.858413 5.25459 3.05558 3.05558C5.25459 0.858413 8.81597 0.858413 11.015 3.05558C13.2121 5.25459 13.2121 8.81597 11.015 11.015Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/ZoomIn.b83c8b2f22f45dccb7ae3329b3fd89c6.svg";
export { ForwardRef as ReactComponent };